import { Component, Input, OnInit } from "@angular/core";
import { MenuCloseReason } from "@angular/material/menu/menu";

export interface MenuAction {
  label: string;
  iconClass?: string;
  actionClass?: string;
  action: (context: any) => void;
  checkDisabled?: (context: any) => boolean;
  checkVisible?: (context: any) => boolean;
}

export interface MenuDivider {}

@Component({
  selector: "eris-menu",
  templateUrl: "./eris-menu.component.html",
  styleUrls: ["./eris-menu.component.sass"],
})
export class ErisMenuComponent implements OnInit {
  @Input() context: any;
  @Input() menuConfiguration?: (MenuAction | MenuDivider)[];
  @Input() onMenuClosed?: (closeReason: MenuCloseReason) => void;
  @Input() onMenuOpened?: () => void;

  constructor() {}

  ngOnInit(): void {}

  isMenuAction(item: any): boolean {
    return !!item.label;
  }

  executeMenuAction = (menuAction: MenuAction) => {
    if (menuAction && menuAction.action) {
      menuAction.action(this.context);
    }
  };

  internalOnMenuClosed = (closeReason: MenuCloseReason) => {
    if (!!this.onMenuClosed) {
      this.onMenuClosed(closeReason);
    }
  };

  internalOnMenuOpened = () => {
    if (!!this.onMenuOpened) {
      this.onMenuOpened();
    }
  };

  internalCheckDisabled = (menuAction: MenuAction): boolean => {
    if (!!menuAction.checkDisabled) {
      return menuAction.checkDisabled(this.context);
    }
    return false;
  };

    internalCheckVisible = (menuAction: MenuAction): boolean => {
    if (!!menuAction.checkVisible) {
      return menuAction.checkVisible(this.context);
    }
    return true;
  };
}
